import React, { useState } from 'react'
import isMobile from './utility/mobile'

const Introduction = () => {
	let image, device
	const [display, setDisplay] = useState(true)

	if (isMobile()) {
		image = './introduction-sp.png'
		device = 'sp'
	} else {
		image = './introduction-pc.png'
		device = 'pc'
	}

	const onClickIntroduction = () => {
		setDisplay(false)
	}

	return (
		<div className={display ? 'urb-zoo-introduction-show-' + device : 'urb-zoo-introduction-hide'} onClick={onClickIntroduction}>
			<img src={image} alt="introduction" />
		</div>
	)
}

export default Introduction